import React, { useEffect, useState } from 'react';
import Layout from '@/common/Layout';
import { useNavigate } from 'react-router-dom';
import EditCantact from './components/MemberShipDetails';
// import { Form }from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { paymentway, verifyAPI } from './redux/slice';

const index = () => {
  useEffect(() => {
    document.title = 'Membership Plans - Premium Features & Benefits';
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const paymentStatus = useSelector((state) => state.paymentgateway);
  const [selectedPlan, setSelectedPlan] = useState({
    title: '',
    price: '',
    billingFrequency: ''
  });

  console.log('selectedPlan', selectedPlan);

  function parsePrice(priceString) {
    // Regular expression to match currency and amount
    const regex = /^([A-Z]+)\s*([\d,]+(?:\.\d{1,2})?)$/;
    const match = priceString.match(regex);

    if (match) {
      const currency = match[1];
      const amount = parseFloat(match[2].replace(/,/g, ''));
      return { currency, amount };
    } else {
      throw new Error('Price string is in an unrecognized format.');
    }
  }

  // let currency, amount;
  // try {
  //   ({ currency, amount } = parsePrice(selectedPlan.price));
  // } catch (error) {
  //   console.error(error.message);
  //   // Handle the error appropriately
  // }

  // // Payment Order Create API called with details
  // const matUserData = localStorage.getItem('MAT-User');
  // const matUserObject = JSON.parse(matUserData);
  // const email = matUserObject.user_details.email;
  // const customerName =
  //   matUserObject.user_details.first_name +
  //   ' ' +
  //   matUserObject.user_details.last_name;

  // // console.log('matUserObject', matUserObject.user_details);

  // const payload = {
  //   trn: crypto.randomUUID(),
  //   amount: amount,
  //   currency: currency,
  //   notes: {
  //     productName: selectedPlan.title,
  //     planType: selectedPlan.billingFrequency,
  //     customerName: customerName,
  //     customerEmail: email
  //   }
  // };
  // dispatch(paymentway(payload));
  // console.log('price_data', payload);

  useEffect(() => {
    if (
      selectedPlan.price &&
      selectedPlan.title &&
      selectedPlan.billingFrequency
    ) {
      try {
        const { currency, amount } = parsePrice(selectedPlan.price);

        const matUserData = localStorage.getItem('MAT-User');
        const matUserObject = JSON.parse(matUserData);
        const email = matUserObject.user_details.email;
        const customerName =
          matUserObject.user_details.first_name +
          ' ' +
          matUserObject.user_details.last_name;

        const payload = {
          trn: crypto.randomUUID(),
          amount: amount,
          currency: currency,
          notes: {
            productName: selectedPlan.title,
            planType: selectedPlan.billingFrequency,
            customerName: customerName,
            customerEmail: email
          }
        };
        localStorage.setItem('order_create', JSON.stringify(payload));
        dispatch(paymentway(payload));
        console.log('price_data', payload);
      } catch (error) {
        console.error(error.message);
      }
    }
  }, [selectedPlan]);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const openRazorpayCheckout = async () => {
    try {
      console.log('Opening Razorpay checkout...');
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        // alert('Razorpay SDK failed to load. Check your internet connection.');
        setLoading(false);
        return;
      }

      console.log('Script loaded successfully');

      const orderDetails = paymentStatus.payment_details;
      console.log('Order details for Razorpay:', orderDetails);

      // Setup Razorpay options
      const options = {
        // key: 'rzp_test_8oey15fzuX4stX',
        key: process.env?.REACT_APP_RAZORPAY_KEY_ID,
        amount: orderDetails.amount,
        currency: orderDetails.currency,
        name: 'Your Company Name',
        description: `Payment for ${orderDetails.notes.productName}`,
        order_id: orderDetails.id, // This is the Razorpay order ID
        handler: async function (response) {
          console.log('Payment successful', response);
          // Handle successful payment
          const resultAction = await dispatch(verifyAPI(response));
          if (verifyAPI.fulfilled.match(resultAction)) {
            console.log('Payment successful', response);
            localStorage.setItem('razorpay_response', JSON.stringify(response));
            // You should verify the payment on your backend here
            navigate('/success');
          } else {
            console.error('Payment verification failed', resultAction.payload);
            navigate('/failure'); // Navigate to failure page
          }
        },
        prefill: {
          name: orderDetails.notes.customerName,
          email: orderDetails.notes.customerEmail
        },
        theme: {
          color: '#3399cc'
        },
        modal: {
          ondismiss: function () {
            console.log('Modal dismissed');
            setLoading(false);
            navigate('/failure'); // Redirect on failure or dismissal
          }
        }
      };
      console.log('Razorpay options:', options);
      // Initialize and open Razorpay
      const razorpay = new window.Razorpay(options);
      razorpay.open();
      console.log('Razorpay modal opened');
    } catch (error) {
      console.error('Error opening Razorpay:', error);
      // alert('Something went wrong. Please try again later.');
      setLoading(false);
    }
  };

  // This effect runs when payment status changes
  useEffect(() => {
    console.log('Payment status changed:', paymentStatus);
    if (paymentStatus.success === true && paymentStatus.payment_details) {
      console.log('Successful payment status detected');
      // Open Razorpay when we have a successful order response
      openRazorpayCheckout();
    } else if (paymentStatus.success === false) {
      setLoading(false);
      // Handle payment failure
      // alert('Failed to create payment. Please try again.');
    }
  }, [paymentStatus]);

  return (
    <>
      <Layout sider={true}>
        <EditCantact
          onsubmit={onsubmit}
          setSelectedPlan={setSelectedPlan}
          selectedPlan={selectedPlan}
          loading={loading}
        />
      </Layout>
    </>
  );
};

export default index;
